/*
  Free-gift auto add/remove for the cart drawer. The bottle
  (variant 54001251287387, "Vit2go Bottle — Free Gift", €0.00) is a
  real Shopify product/variant so it can be a real, fulfillable line
  item — it's just hidden from collections/navigation. Nothing here
  changes what the customer pays; the variant price is already €0.00.

  Threshold must match vit2go-cart-gift-bar.liquid's
  v2g_gift_threshold (currently 5000 = €50.00, in cents, same
  convention the Ajax Cart API uses for cart.total_price).

  Reconciles on: initial page load, every "vit2go:cart:updated" event
  (dispatched by product-page add-to-cart), and every time the
  drawer's DOM is replaced (covers quantity +/-/remove inside the
  drawer, handled by vit2go-cart-items.js). Since the gift is €0.00,
  cart.total_price already excludes its value, so the eligibility
  check needs no special-casing to subtract it back out.
*/
(function () {
  "use strict";

  var GIFT_VARIANT_ID = 54001251287387;
  var GIFT_THRESHOLD = 5000;
  var syncing = false;
  var pending = false;

  // Guards against a retry loop: refreshDrawer() replaces DOM inside
  // #cart-drawer, which the MutationObserver below sees and reacts to
  // by calling sync() again. If adding or removing the gift keeps failing
  // (e.g. the gift variant is out of stock), that would otherwise
  // retry on every single mutation forever, hammering the storefront.
  // Only attempt a reconcile once per distinct cart total; a fresh
  // attempt only happens once the total actually changes again.
  var lastAttemptedTotal = null;
  var lastClampAttempt = null;

  function cartRoute(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
    return root + path;
  }

  function fetchCart() {
    return fetch(cartRoute("cart.js"), { headers: { Accept: "application/json" } }).then(function (res) {
      return res.json();
    });
  }

  function addGift() {
    return fetch(cartRoute("cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }),
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (body) {
          console.warn("vit2go-cart-gift: failed to add free gift (likely out of stock).", body);
          return false;
        }).catch(function () {
          console.warn("vit2go-cart-gift: failed to add free gift, status " + res.status);
          return false;
        });
      }
      return true;
    });
  }

  // cart/change.js rejects a numeric id (400), so change lines by their string key.
  function changeGift(lineKey, quantity) {
    return fetch(cartRoute("cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    }).then(function (res) {
      if (!res.ok) {
        console.warn("vit2go-cart-gift: failed to change free gift to " + quantity + ", status " + res.status);
        return false;
      }
      return true;
    });
  }

  function refreshDrawer() {
    var current = document.querySelector(".cart-drawer__inner");
    if (!current) return Promise.resolve();

    return fetch(window.location.pathname + "?section_id=cart-drawer-section", {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var freshInner = doc.querySelector(".cart-drawer__inner");
        var stillCurrent = document.querySelector(".cart-drawer__inner");
        if (freshInner && stillCurrent) {
          stillCurrent.replaceWith(freshInner);
        }
      })
      .catch(function () {});
  }

  function reconcile(cart) {
    var giftLine = cart.items.filter(function (item) {
      return item.variant_id === GIFT_VARIANT_ID;
    })[0];
    var hasGift = !!giftLine;
    var eligible = cart.total_price >= GIFT_THRESHOLD;

    // One bottle per customer: the gift line must never go above 1 (the full
    // cart page shows a quantity stepper for it).
    if (eligible && giftLine && giftLine.quantity > 1) {
      var clampId = giftLine.key + ":" + giftLine.quantity;
      if (clampId !== lastClampAttempt) {
        lastClampAttempt = clampId;
        return changeGift(giftLine.key, 1).then(function (ok) {
          if (ok) return refreshDrawer();
        });
      }
    }

    if (eligible === hasGift) {
      // Already correct, nothing to do (also covers the case where an
      // earlier attempt at this exact total already failed — see the
      // lastAttemptedTotal guard in sync(), which is what stops this
      // from being retried forever).
      return Promise.resolve();
    }

    if (cart.total_price === lastAttemptedTotal) {
      // Already tried to fix this exact total once; don't hammer the
      // storefront retrying the same failing request.
      return Promise.resolve();
    }
    lastAttemptedTotal = cart.total_price;

    var action = eligible ? addGift() : changeGift(giftLine.key, 0);
    return action.then(function (succeeded) {
      if (succeeded) return refreshDrawer();
    });
  }

  function sync() {
    if (syncing) {
      pending = true;
      return;
    }
    syncing = true;
    fetchCart()
      .then(reconcile)
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (pending) {
          pending = false;
          sync();
        }
      });
  }

  // Initial state, in case a customer already had €50+ in their cart
  // before this feature existed, or arrives from a saved/shared cart.
  sync();

  document.addEventListener("vit2go:cart:updated", function () {
    sync();
  });

  // Catches drawer quantity/remove changes (vit2go-cart-items.js
  // replaces .cart-drawer__inner on every change, same signal it
  // uses internally to re-bind its own click handlers).
  // Also covers applying or removing a discount code in the drawer: the
  // theme morphs the drawer in place, so text can change without nodes being
  // added or removed. The threshold is checked against cart.total_price,
  // which is the amount AFTER discounts.
  var syncTimer = null;
  function syncSoon() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 300);
  }
  // On the full cart page there is no drawer, so watch the page content instead.
  var drawerRoot = document.getElementById("cart-drawer") || document.querySelector("main");
  if (drawerRoot) {
    var observer = new MutationObserver(syncSoon);
    observer.observe(drawerRoot, { childList: true, subtree: true, characterData: true });
  }
})();
